import { GalleryAgentSticky } from './gallery-agent-sticky';

export default GalleryAgentSticky;
